<template>
    <div class="row">
        <div class="col-12 col-md-12 note-head">
            <div class="note-title">
                <h4>{{ dentitionType === 'primary' ? 'Primary Dentition' : 'Permanent Dentition' }}</h4>
            </div>
        </div>
        <div class="col-21">
            <hr class="mt-0">
        </div>
        <div class="col-12 col-md-12 note-body">
            <div class="card card-body">
              <div :class="wrapperClass">
                <div class="col-12 parent-permanent-partition">
                  <div class="row permanent-partition-row">
                    <div
                        v-for="(item, key) in dentitionTeethNumbers"
                        :key="key"
                        class="col-6 row permanent-partition-col d-flex justify-content-between"
                    >
                      <div class="col-12">
                        {{ permanentDentitionPosition[key] || key }}
                      </div>

                      <div class="col-12 d-flex justify-content-between">
                        <button
                            v-for="i in item"
                            :key="i"
                            class="btn cancel-subscription waves-effect num-btn btn-sm"
                            :class="selectedDentition.includes(i) ? 'btn-primary' : 'btn-outline-primary'"
                            @click="onSelectDentition(i, 'permanent')"
                        >
                          {{ getDentitionNumber(i) }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <BillingDetailModal 
            v-if="isShowBillingDetail"
            v-model:isShowBillingDetail="isShowBillingDetail"
            :tableItems="tableItems"
        />
    </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import BillingDetailModal from '@/components/molecule/company/dental-os/service/middle-header/BillingDetailModal.vue';

const props = defineProps({
    dentition: {
        type: Object || null,
        default: () => {}
    },
    dentitionType: {
        type: String || null,
        default: null,
    },
    billedDentition: {
        type: Object || null,
        default: () => {}
    },
});

const isShowBillingDetail = ref(false);
const tableItems = ref({});
const wrapperClass = computed(() => {
    return props.dentition.notation_type === 'universal' && props.dentitionType === 'primary' ? '' : 'dentition-wrapper';
});

const dentitionTeethNumbers = computed(() => {

    if (! props.dentition) return [];

    const prefix = props.dentition.notation_type === 'fdi' ? 'fdi_' : '';

    if (props.dentitionType === 'permanent') {
        return props.dentition && props.dentition[prefix + 'permanent_dentition'];
    }

    return props.dentition && props.dentition[prefix + 'primary_dentition'];
});

const selectedDentition = ref([]);
const permanentDentitionPosition = {
    top_start: 'Upper Right',
    top_end: 'Upper Left',
    bottom_start: 'Lower Right',
    bottom_end: 'Lower Left',
};

const closeModal = () => {
    emit('update:isOpenModal', false);
}

const onSelectDentition = (toothNumber) => {
    tableItems.value = props.billedDentition[toothNumber] || {};
    isShowBillingDetail.value = true;
}

const submit = () => {
    emit('onSaveDentition', selectedDentition.value);
    closeModal();
}

const getDentitionNumber = (i) => {
    let match = i.match(/-(.*)/);
    let position = match ? match[1] : i;

    if(props.dentitionType === 'primary') {
        return position.toUpperCase();
    }
    
    return position.padStart(2, '0').toUpperCase();
}

watch(() => props.billedDentition, (newVal) => {
    selectedDentition.value = Object.keys(newVal);
}, { deep: true })
</script>

<style scoped>
.dentition-title {
    margin-bottom: 4px;
}
.note-title {
    min-width: 200px;
}
.note-body .card-body{
    padding: 0 2%;
}
.note-head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1%;
}
.action .close {
    color: red;
    cursor: pointer;
}
.note-body .card {
    background: #ffffff;
    min-height: 100px;
    margin-bottom: 1rem;
}
.dentition-wrapper {
  position: relative;
}
.dentition-wrapper::before {
  content: '';
  position: absolute;
  top: 2px;
  bottom: 2px;
  width: 2px;
  background: #d7d7d7;
  left:50%;
  transform: translateX(-50%);
  z-index: 1;
}
.dentition-wrapper::after {
  content: '';
  position: absolute;
  left: 2px;
  right: 2px;
  height: 2px;
  background: #d7d7d7;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}
.permanent-partition-row,
.permanent-partition-col  {
  position: relative;
  z-index: 2;
}
.num-btn {
    padding-left: .8rem;
    padding-right: .8rem;
}
.permanent-partition-row {
    display: flex;
    border-radius: 5px;
    border: 1px solid #e9e9e9;
    padding: 10px 11px 5px 0px;
    margin: 2px;
    justify-content: space-between;
}
.primary-partition-row {
    border-radius: 5px;
    border: 1px solid #e9e9e9;
    padding: 10px 0px 5px 0px;
    margin-left: -3px;
    margin-right: 0px;
}
.permanent-partition-col {
    padding-right: 0;
    margin-bottom: 15px;
    margin-top: 8px;
}
.primary-partition-col {
    margin-bottom: 8px;
}
@media (max-width: 768px) {
  .permanent-partition-col {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .dentition-wrapper::before,
  .dentition-wrapper::after {
    display: none;
  }

  .permanent-partition-row {
    padding: 10px;
  }
}
</style>